CCL.topNav = {
  autoload: [
    ['mNavDropdownToggle', $('.m-nav-dropdown-link').length > 0],
    ['notificationDropdownMenu', $('.notification-dropdown-menu').length > 0]
  ],

  mNavDropdownToggle() {
    $('.m-nav-dropdown-link').each((index, element) => {
      $(element).click((event) => {
        event.preventDefault();
        $(element).toggleClass('open');
        const targetElement = $(event.target).parents('.m-nav-dropdown').find('.m-nav-dropdown-menu');
        const expanded = $(event.currentTarget).attr('aria-expanded');
        $(targetElement).slideToggle();
        if (expanded === 'false') {
          $(event.currentTarget).attr('aria-expanded', 'true');
        } else {
          $(event.currentTarget).attr('aria-expanded', 'false');
        }
      });
    });
  },

  notificationDropdownMenu() {
    $('.notification-submenu-href img, .notification-submenu-href').on('click keypress', (event) => {
      $(event.target).parents('.dropdown-submenu-wrap').find('.dropdown-menu').toggleClass('show');

      event.stopPropagation();
    });

    $('.notification-dropdown-anchor').on('click keypress', (event) => {
      $('.dropdown-submenu-wrap').find('.dropdown-menu').removeClass('show');
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-top-nav/top-nav.js